/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementWithLatestInstanceDTO,
  AgreementWithLatestInstanceDTOOptional,
  AgreementWithLatestInstanceDTOMetaI,
  AgreementWithLatestInstanceDTOTrackedI,
} from "./agreement-with-latest-instance-dto";
import {
  AgreementWithLatestInstanceDTOTracked,
  AgreementWithLatestInstanceDTOMeta,
} from "./agreement-with-latest-instance-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAgreementFullDTO,
  PersonAgreementFullDTOOptional,
  PersonAgreementFullDTOMetaI,
  PersonAgreementFullDTOTrackedI,
} from "./person-agreement-full-dto";
import {
  PersonAgreementFullDTOTracked,
  PersonAgreementFullDTOMeta,
} from "./person-agreement-full-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAgreementInstanceDTO,
  PersonAgreementInstanceDTOOptional,
  PersonAgreementInstanceDTOMetaI,
  PersonAgreementInstanceDTOTrackedI,
} from "./person-agreement-instance-dto";
import {
  PersonAgreementInstanceDTOTracked,
  PersonAgreementInstanceDTOMeta,
} from "./person-agreement-instance-dto";

/**
 *
 * @export
 * @interface PersonAgreementInternalDTO
 */
export interface PersonAgreementInternalDTOOptional extends PersonAgreementFullDTOOptional {
  /**
   *
   * @type {AgreementWithLatestInstanceDTO}
   * @memberof PersonAgreementInternalDTO
   */
  agreementId?: AgreementWithLatestInstanceDTOOptional;
  /**
   *
   * @type {PersonAgreementInstanceDTO}
   * @memberof PersonAgreementInternalDTO
   */
  latestAgreementAction?: PersonAgreementInstanceDTOOptional;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInternalDTO
   */
  isAgreed?: boolean;
  /**
   *
   * @type {Array<PersonAgreementInstanceDTO>}
   * @memberof PersonAgreementInternalDTO
   */
  allAgreementActions?: PersonAgreementInstanceDTOOptional[];
}

export interface PersonAgreementInternalDTO
  extends PersonAgreementInternalDTOOptional, PersonAgreementFullDTO {
  /**
   *
   * @type {AgreementWithLatestInstanceDTO}
   * @memberof PersonAgreementInternalDTO
   */
  agreementId?: AgreementWithLatestInstanceDTO;
  /**
   *
   * @type {PersonAgreementInstanceDTO}
   * @memberof PersonAgreementInternalDTO
   */
  latestAgreementAction?: PersonAgreementInstanceDTO;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInternalDTO
   */
  isAgreed?: boolean;
  /**
   *
   * @type {Array<PersonAgreementInstanceDTO>}
   * @memberof PersonAgreementInternalDTO
   */
  allAgreementActions?: PersonAgreementInstanceDTO[];
}

export interface PersonAgreementInternalDTOTrackedI extends PersonAgreementFullDTOOptional {
  /**
   *
   * @type {AgreementWithLatestInstanceDTO}
   * @memberof PersonAgreementInternalDTO
   */
  agreementId?: AgreementWithLatestInstanceDTOTrackedI;
  agreementIdIsSet: boolean;
  /**
   *
   * @type {PersonAgreementInstanceDTO}
   * @memberof PersonAgreementInternalDTO
   */
  latestAgreementAction?: PersonAgreementInstanceDTOTrackedI;
  latestAgreementActionIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInternalDTO
   */
  isAgreed?: boolean;
  isAgreedIsSet: boolean;
  /**
   *
   * @type {Array<PersonAgreementInstanceDTO>}
   * @memberof PersonAgreementInternalDTO
   */
  allAgreementActions?: PersonAgreementInstanceDTOTrackedI[];
  allAgreementActionsIsSet: boolean;
}

transformDatesMap.set(
  "PersonAgreementInternalDTO",
  function (model: PersonAgreementInternalDTO) {
    const transformDatesagreementId = transformDatesMap.get(
      "AgreementWithLatestInstanceDTO",
    );
    if (transformDatesagreementId && model.agreementId) {
      transformDatesagreementId(model.agreementId);
    }
    const transformDateslatestAgreementAction = transformDatesMap.get(
      "PersonAgreementInstanceDTO",
    );
    if (transformDateslatestAgreementAction && model.latestAgreementAction) {
      transformDateslatestAgreementAction(model.latestAgreementAction);
    }
    const transformDatesallAgreementActions = transformDatesMap.get(
      "PersonAgreementInstanceDTO",
    );
    if (transformDatesallAgreementActions) {
      model.allAgreementActions?.forEach((sub) => {
        transformDatesallAgreementActions(sub);
      });
    }
  },
);

export type PersonAgreementInternalDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  agreementId: PropertyMeta<AgreementWithLatestInstanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  latestAgreementAction: PropertyMeta<PersonAgreementInstanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  isAgreed: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  allAgreementActions: PropertyMeta<PersonAgreementInstanceDTOMetaI>;
}>;

export var PersonAgreementInternalDTOMeta: PersonAgreementInternalDTOMetaI =
  {} as PersonAgreementInternalDTOMetaI;
PersonAgreementInternalDTOMeta = typeMeta("PersonAgreementInternalDTO", {
  agreementId: propertyMeta(
    "agreementId",
    false,
    false,
    false,
    AgreementWithLatestInstanceDTOMeta,
  ),
  latestAgreementAction: propertyMeta(
    "latestAgreementAction",
    false,
    false,
    false,
    PersonAgreementInstanceDTOMeta,
  ),
  isAgreed: propertyMeta(
    "isAgreed",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  allAgreementActions: propertyMeta(
    "allAgreementActions",
    true,
    false,
    false,
    PersonAgreementInstanceDTOMeta,
  ),
});

const metaI = PersonAgreementInternalDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonAgreementFullDTOMeta]);
  metaI.agreementId.inheritedFrom = PersonAgreementFullDTOMeta.agreementId;
  metaI.latestAgreementAction.inheritedFrom =
    PersonAgreementFullDTOMeta.latestAgreementAction;
  metaI.isAgreed.inheritedFrom = PersonAgreementFullDTOMeta.isAgreed;
});

export class PersonAgreementInternalDTOTracked
  extends PersonAgreementFullDTOTracked
  implements PersonAgreementInternalDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  agreementId__I?: AgreementWithLatestInstanceDTOTracked = undefined;
  agreementIdIsSet: boolean = false;
  set agreementId(v: undefined | AgreementWithLatestInstanceDTOTracked) {
    if (v !== undefined) {
      this.agreementId__I = v;
      this.agreementIdIsSet = true;
    } else {
      this.agreementId__I = v || undefined;
      this.agreementIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementId() {
    return this.agreementId__I;
  }
  latestAgreementAction__I?: PersonAgreementInstanceDTOTracked = undefined;
  latestAgreementActionIsSet: boolean = false;
  set latestAgreementAction(v: undefined | PersonAgreementInstanceDTOTracked) {
    if (v !== undefined) {
      this.latestAgreementAction__I = v;
      this.latestAgreementActionIsSet = true;
    } else {
      this.latestAgreementAction__I = v || undefined;
      this.latestAgreementActionIsSet = false;
    }
    this.changeTracker = true;
  }
  get latestAgreementAction() {
    return this.latestAgreementAction__I;
  }
  isAgreed__I?: boolean = undefined;
  isAgreedIsSet: boolean = false;
  set isAgreed(v: undefined | boolean) {
    if (v !== undefined) {
      this.isAgreed__I = v;
      this.isAgreedIsSet = true;
    } else {
      this.isAgreed__I = v || undefined;
      this.isAgreedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isAgreed() {
    return this.isAgreed__I;
  }
  allAgreementActions__I?: PersonAgreementInstanceDTOTracked[] = undefined;
  allAgreementActionsIsSet: boolean = false;
  set allAgreementActions(v: undefined | PersonAgreementInstanceDTOTracked[]) {
    if (v !== undefined) {
      this.allAgreementActions__I = v;
      this.allAgreementActionsIsSet = true;
    } else {
      this.allAgreementActions__I = v || undefined;
      this.allAgreementActionsIsSet = false;
    }
    this.changeTracker = true;
  }
  get allAgreementActions() {
    return this.allAgreementActions__I;
  }
  constructor(
    config?: PersonAgreementInternalDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.agreementId?.setIds();

    this.latestAgreementAction?.setIds();

    this.allAgreementActions?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PersonAgreementInternalDTOOptional,
    options?: AssignOptions,
  ): PersonAgreementInternalDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.agreementId &&
      this.agreementIdApplyFilter(optionsRequired.filter)
    ) {
      this.agreementId = new AgreementWithLatestInstanceDTOTracked(
        config.agreementId,
        options,
      );
      if (optionsRequired.unassign) this.agreementIdIsSet = false;
      else this.agreementIdIsSet = true;
    }
    if (
      config.latestAgreementAction &&
      this.latestAgreementActionApplyFilter(optionsRequired.filter)
    ) {
      this.latestAgreementAction = new PersonAgreementInstanceDTOTracked(
        config.latestAgreementAction,
        options,
      );
      if (optionsRequired.unassign) this.latestAgreementActionIsSet = false;
      else this.latestAgreementActionIsSet = true;
    }
    if (config.isAgreed && this.isAgreedApplyFilter(optionsRequired.filter)) {
      this.isAgreed = config.isAgreed;
      if (optionsRequired.unassign) this.isAgreedIsSet = false;
      else this.isAgreedIsSet = true;
    }
    if (
      config.allAgreementActions &&
      this.allAgreementActionsApplyFilter(optionsRequired.filter)
    ) {
      this.allAgreementActions = config.allAgreementActions?.map(
        (a) => new PersonAgreementInstanceDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.allAgreementActionsIsSet = false;
      else this.allAgreementActionsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAgreementInternalDTOTrackedI {
    const cloned = {} as PersonAgreementInternalDTOTrackedI;
    if (
      this.agreementIdIsSetDeep() &&
      this.agreementIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementIdIsSet = true;
      cloned.agreementId = this.agreementId?.removeUnset(filter);
    } else {
      //cloned.agreementIdIsSet = false
    }
    if (
      this.latestAgreementActionIsSetDeep() &&
      this.latestAgreementActionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.latestAgreementActionIsSet = true;
      cloned.latestAgreementAction =
        this.latestAgreementAction?.removeUnset(filter);
    } else {
      //cloned.latestAgreementActionIsSet = false
    }
    if (
      this.isAgreedIsSetDeep() &&
      this.isAgreedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAgreedIsSet = true;
      cloned.isAgreed = this.isAgreed;
    } else {
      //cloned.isAgreedIsSet = false
    }
    if (
      this.allAgreementActionsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.allAgreementActionsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allAgreementActionsIsSet = true;
      cloned.allAgreementActions = this.allAgreementActions
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.allAgreementActionsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAgreementInternalDTOTrackedI {
    if (!this.agreementIdApplyFilter(filter)) this.agreementIdIsSet = false;
    this.agreementId?.unassignAll(filter);

    if (!this.latestAgreementActionApplyFilter(filter))
      this.latestAgreementActionIsSet = false;
    this.latestAgreementAction?.unassignAll(filter);

    if (!this.isAgreedApplyFilter(filter)) this.isAgreedIsSet = false;

    if (!this.allAgreementActionsApplyFilter(filter))
      this.allAgreementActionsIsSet = false;

    this.allAgreementActions?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  agreementIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInternalDTOMeta.agreementId,
      PersonAgreementInternalDTOMeta,
      this.agreementId,
      this,
    );
  }
  agreementIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementIdIsSet && this.agreementIdApplyFilter(filter))
      return true;
    return this.agreementId?.anySet(filter) == true;

    return false;
  }
  latestAgreementActionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInternalDTOMeta.latestAgreementAction,
      PersonAgreementInternalDTOMeta,
      this.latestAgreementAction,
      this,
    );
  }
  latestAgreementActionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.latestAgreementActionIsSet &&
      this.latestAgreementActionApplyFilter(filter)
    )
      return true;
    return this.latestAgreementAction?.anySet(filter) == true;

    return false;
  }
  isAgreedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInternalDTOMeta.isAgreed,
      PersonAgreementInternalDTOMeta,
      this.isAgreed,
      this,
    );
  }
  isAgreedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isAgreedIsSet && this.isAgreedApplyFilter(filter)) return true;

    return false;
  }
  allAgreementActionsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInternalDTOMeta.allAgreementActions,
      PersonAgreementInternalDTOMeta,
      this.allAgreementActions,
      this,
    );
  }
  allAgreementActionsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.allAgreementActionsIsSet &&
      this.allAgreementActionsApplyFilter(filter)
    )
      return true;

    return this.allAgreementActions?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.agreementIdIsSetDeep(filter)) return true;
    if (this.latestAgreementActionIsSetDeep(filter)) return true;
    if (this.isAgreedIsSetDeep(filter)) return true;
    if (this.allAgreementActionsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
